<template>
  <chart :chart-options="chartOptions" />
</template>

<script>
import HighchartsFormattingWrapper from './HighchartsFormattingWrapper'

export default {
  name: 'StackedColumnChart',
  components: {
    chart: HighchartsFormattingWrapper
  },
  props: {
    chartData: { type: Object, default: () => ({}) },
    parseDate: { type: Boolean, default: false }
  },
  computed: {
    series () {
      return Object.entries(this.chartData)
        .sort((a, b) => a[0] - b[0])
        .reduce((s, [xAxisValue, groups]) => {
          const newSeries = [...s]
          Object.entries(groups).forEach(([groupName, dataPoint]) => {
            const currentSeries = newSeries.find(series => series.name === groupName)
            // TODO remove statuscode related logic from generic stacked column chart component
            if (!currentSeries) {
              let color = '#2b7'
              if (parseInt(groupName) > 499) {
                color = '#CC1F1A'
              } else if (parseInt(groupName) > 399) {
                color = '#fb1'
              }
              newSeries.push({ name: groupName, data: [{ x: parseInt(xAxisValue), y: dataPoint }], color })
            } else {
              currentSeries.data.push({ x: parseInt(xAxisValue), y: dataPoint })
            }
          })
          return newSeries
        }, [])
    },
    chartOptions () {
      return {
        chart: {
          type: 'column'
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('Number of calls', 'Number of calls')
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold'
            }
          }
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true
            }
          }
        },
        series: this.series
      }
    }
  }
}
</script>
